module.exports = __webpack_public_path__ + "media/images/icons/flags/WS-fd5be6847265782a5a14aa5f4c03ef13.svg";